import { observable, observer } from '@poa/state';
import React from 'react';
import { findIsFilterOnServerSideHeaderId } from './data-table-helpers';

const ignoreSorting = ['social', 'status', 'photo'];

const DataTableCell = observer(
  class DataTableCell extends React.Component {
    sortMode = observable(this.props.sortingMap.get(this.props.headerData.name) || 'none');

    onClick = () => {
      if (this.sortMode.get() === 'none') {
        this.sortMode.set('asc');
        this.onSort();
        return;
      }

      if (this.sortMode.get() === 'asc') {
        this.sortMode.set('desc');
        this.onSort();
        return;
      }

      if (this.sortMode.get() === 'desc') {
        this.sortMode.set('none');
        this.onSort();
      }
    };

    onSort() {
      this.props.onSort({ mode: this.sortMode.get(), header: this.props.headerData.name });
    }

    render() {
      const {
        innerRef,
        headerData,
        shouldShowSeparator,
        onSort,
        sortingMap,
        data,
        ...rest
      } = this.props;
      const style = { cursor: 'pointer', userSelect: 'none', width: headerData.width };

      if (findIsFilterOnServerSideHeaderId(data.get().thead, headerData.name)) {
        style.backgroundColor = 'rgba(204, 204, 204, 0.2)';
      }

      let arrow;

      switch (this.sortMode.get()) {
        case 'none':
          arrow = '';
          break;
        case 'asc':
          arrow = '&uarr;';
          break;
        case 'desc':
          arrow = '&darr;';
          break;
        default:
          arrow = '';
          break;
      }

      return (
        <th
          {...rest}
          onClick={ignoreSorting.includes(headerData.name) ? undefined : this.onClick}
          className={`${shouldShowSeparator ? 'table__separator' : ''}`}
          style={style}
          ref={theadEl => this.props.innerRef(theadEl)}
          dangerouslySetInnerHTML={{
            __html: `${headerData.label} ${arrow}`
          }}
        />
      );
    }
  }
);


export const DataTableHeader = observer(
  class DataTableHeader extends React.Component {
    componentDidMount() {
      if (this.props.headerSticky) {
        window.addEventListener('scroll', this.onScroll);
      }
    }

    onScroll = () => {
      requestAnimationFrame(() => {
        const filtersHeight = document.getElementsByClassName('filters')[0].getBoundingClientRect()
          .height;

        const offset = filtersHeight + this.props.headerSticky;

        if (window.pageYOffset > 220) {
          this.theadRootEl.style.transform = 'translateY(' + (window.pageYOffset - offset) + 'px)';
        } else {
          this.theadRootEl.style.transform = 'translateY(0px)';
        }
      });
    };

    componentDidUpdate() {
      if (!this.props.headerSticky) {
        window.removeEventListener('scroll', this.onScroll);
      }
    }

    componentWillUnmount() {
      if (this.props.headerSticky) {
        window.removeEventListener('scroll', this.onScroll);
      }
    }

    render() {
      const { headerEls, headersOrder, onSort, sortingMap, data } = this.props;

      const thead = [];

      headersOrder.get().forEach((columnSetting, index) => {
        if (columnSetting.name.includes('@@')) {
          return;
        }

        if (columnSetting && columnSetting.isSelected === false) {
          return;
        }

        const nextColumnSetting = headersOrder.get()[index - 1];
        const shouldShowSeparator = (nextColumnSetting || { name: '' }).name.startsWith('@@');

        thead.push(
          <DataTableCell
            sortingMap={sortingMap}
            key={`head-${columnSetting.name}`}
            headerData={columnSetting}
            data={data}
            shouldShowSeparator={shouldShowSeparator}
            onSort={onSort}
            innerRef={theadEl => headerEls.add(theadEl)}
          />
        );
      });

      return (
        <thead ref={node => (this.theadRootEl = node)}>
          <tr>{thead}</tr>
        </thead>
      );
    }
  }
);
